import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Button } from 'blaze-ui/Button'
import { Menu } from 'components/Menu/Menu'
import { SelectableItem } from 'components/Menu/MenuItem'
import { Key } from 'react'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { ItemElement } from '@react-types/shared'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { integrationToName } from 'components/IntegrationRequiredModal/IntegrationRequiredModal'
import { PlatformIcon } from 'screens/ScheduledPosts/PlatformIcon'
import { Plus } from 'blaze-ui/icons'

interface Props extends Pick<ButtonProps, 'size'> {
  onChange?: (channel: ExternalIntegrationEnum) => void
  value?: ExternalIntegrationEnum[]
}

export const POSTABLE_PROVIDERS = [
  ExternalIntegrationEnum.Facebook,
  ExternalIntegrationEnum.Instagram,
  ExternalIntegrationEnum.LinkedIn,
  ExternalIntegrationEnum.X,
]

const ChannelDropdown = ({ onChange, value }: Props) => {
  const handleAction = (key: Key) => {
    onChange?.(key as ExternalIntegrationEnum)
  }

  const allProvidersSelected = POSTABLE_PROVIDERS.every((provider) => value?.includes(provider))

  if (allProvidersSelected) {
    return null
  }

  return (
    <MenuTrigger>
      <Button variant="ghost" size="md" frontIcon={Plus}>
        New Channel
      </Button>
      <Menu
        onAction={handleAction}
        aria-label="Brand Kit"
        showCheckmark
        selectionMode="multiple"
        selectedKeys={value as Key[]}
      >
        {
          POSTABLE_PROVIDERS.filter((provider) => !value?.includes(provider)).map((provider) => (
            <SelectableItem type="item" key={provider} textValue={integrationToName[provider]}>
              <PlatformIcon platform={provider} size={20} />
              <span>{integrationToName[provider]}</span>
            </SelectableItem>
          )) as ItemElement<HTMLElement>[]
        }
      </Menu>
    </MenuTrigger>
  )
}

export { ChannelDropdown }
